import React, { Component } from "react";
import axios from "axios";
import Window from "../../../../elements/window";
import Loader from "../../../../../settings/loader";
import Slide1 from "./slides/slide1";

export default class Sales extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        sales: {
          data: [],
          state: false,
        },
        payType: {
          data: [],
          state: false,
        },
        brands: {
          data: [],
          state: false,
        },
        chains: {
          data: [],
          state: false,
        },
        currency: {
          base: {},
          state: false,
        },
        state: false,
      },
      load: 0,
    };
  }

  async getPaytype(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/paytype",
        { headers }
      );
      callback(response.data);
    } catch (error) {
      callback([]);
    }
  }

  async getBrand(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/brand",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch (error) {
      callback([]);
    }
  }

  async getChain(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/chain",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch (error) {
      callback([]);
    }
  }

  async getData(headers, callback) {
    try {
      const response = await axios.post(
        this.props.chimeraserv.urlGet + "/sales/set/0/",
        { id: this.props.filter.base64 },
        { headers }
      );

      callback(response.data);
    } catch (error) {
      callback([]);
    }
  }

  async getCurrency(headers, callback) {
    try {
      const response = await axios.get(
        this.props.chimeraserv.urlGet + "/group",
        { headers }
      );
      let data = [];
      if (Object.keys(response.data).length) {
        data = response.data;
      }
      callback(data);
    } catch (error) {
      callback([]);
    }
  }

  async componentDidMount() {
    if (this.props.user.data) {
      const headers = {
        Authorization: this.props.user.data.usrKey,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      this.getData(headers, (data) => {
        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            sales: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getPaytype(headers, (data) => {
        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            payType: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getChain(headers, (data) => {
        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            chains: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getBrand(headers, (data) => {
        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            brands: {
              data: data,
              state: true,
            },
          },
        }));
      });

      this.getCurrency(headers, (data) => {
        const array = [];
        const currency = data
          .map((group) => group.baseCurr)
          .filter((currency) => !array.includes(currency));
        this.setState((prevState) => ({
          data: {
            ...prevState.data,
            currency: {
              base: currency[0] ? currency[0].toUpperCase() : "QAR",
              state: true,
            },
          },
        }));
      });
    }
  }

  componentDidUpdate() {
    if (
      this.state.data.currency.state &&
      this.state.data.sales.state &&
      this.state.data.brands.state &&
      this.state.data.chains.state &&
      !this.state.load
    ) {
      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          state: true,
        },
        load: 1,
      }));
    }
  }

  render() {
    return (
      <section>
        {!this.state.load ? (
          <Loader />
        ) : (
          <div>
            <Window
              user={this.props.user}
              chimeraserv={this.props.chimeraserv}
              title={"Sales by Items"}
            >
              <Slide1
                {...this.state}
                user={this.props.user}
                chimeraserv={this.props.chimeraserv}
                filter={this.props.filter}
                data={this.state.data}
              />
            </Window>
          </div>
        )}
      </section>
    );
  }
}
